import { Navigate, Outlet } from "react-router-dom";
import Session from "./Session";


export function copyTextToClipboard(text: string) {
    var input = document.createElement('textarea');
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    Session.app.setState({
        snackbarOpen: true,
        snackbarSeverity: "success",
        message: "Copied to clipboard!"
    });
    return result;
}


export function titleCase(str: string) {
    str = str.replaceAll("_", " ");
    str = str.replaceAll("/", " ").trim();
    const words = str.split(" ");

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
}


export const ProtectedRoute = (props: any) => {

    if (!Session.verified) {
        Session.redirectPath = props.path || "";
        if (!Session.verifying) {
            if (Session.isLocalhost) {
                console.log("Protected Route: Verify Token");
            }
            Session.verify_token(false, true);
        }
    }

    if (Session.token !== "") {
        return <Outlet />;
    } else {
        return <Navigate to={"/"} replace />;
    }
};
